import { useEffect, useState } from "react";
import { WIDGET_ICONS } from "../../../../../../constants";
import ImageRadio from "../../../../../../parts/inputs/image-radio";
import ImageWidgetUploadInput from "../../../../../../parts/inputs/image-widget-upload";
import scriptLoader from "../../../../../../utils/scriptLoader";
import { isPullActiveCoach } from "../../../../../../utils/user-helpers";
import { deleteWidgetUtil, orderWidgets } from "../../../../../../utils/widgets";
import { EditPlaylist } from "./EditPlaylist";
import { S3 } from "../../../../../../constants";

import submit from "submit-form";
import { getUserToRequest } from "../../../../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import ConfirmationModal from "../../../../../../parts/modals/ConfirmationModal";
import WidgetManagerHeader from "./WidgetManagerHeader";
import SvgIcon from "../../../../../../parts/SvgIcon";
import { EditWidgetInfoModal } from "../../../../../../parts/modals/EditWidgetInfo";
import useCompareState from "../../../../../../hooks/useCompareState";

/**
 * Publish a playlist
 * @param {*} e
 * @param {*} id
 */
const publishWidget = (e, id) => {
  e.stopPropagation();
  e.preventDefault();
  submit(`/actions/video-playlist/status/${id}`, {
    method: "POST",
    body: { status: "published" },
  });
};

/**
 * Unpublish a playlist
 * @param {*} e
 * @param {*} id
 */
const unpublishWidget = (e, id) => {
  e.stopPropagation();
  e.preventDefault();
  submit(`/actions/video-playlist/status/${id}`, {
    method: "POST",
    body: { status: "draft" },
  });
};

/**
 * Change the status of a playlist
 * @param {*} param0
 * @returns
 */

const WidgetToggle = ({ status, id }) => {
  const [value, setValue] = useState(status === "draft" ? false : true);
  const [openedConfirmationModal, setOpenedConfirmationModal] = useState(false);

  const handleChange = (e) => {
    !value ? unpublishWidget(e, id) : publishWidget(e, id);
    setTimeout(() => {
      setOpenedConfirmationModal(false);
    }, 500);
  };
  return (
    <>
      <input
        type="checkbox"
        id={`switch-${id}`}
        name={`switch-${id}`}
        role="switch"
        onChange={() => {
          setValue(!value);
          setOpenedConfirmationModal(!openedConfirmationModal);
        }}
        checked={value ? true : undefined}
      />
      <ConfirmationModal
        title={!value ? "Unpublish" : "Publish"}
        contentText={`Are you sure you want to ${
          !value ? "unpublish" : "publish"
        } this widget`}
        cancelButtonText="Cancel"
        cancelButtonAction={() => {
          setOpenedConfirmationModal(false);
          setValue(!value);
        }}
        confirmButtonText={!value ? "Unpublish" : "Publish"}
        confirmButtonAction={(e) => handleChange(e, id)}
        isOpen={openedConfirmationModal}
      />
    </>
  );
};
export const VideoWidgetManager = ({ locals, goBack }) => {
  const activeWidget = locals.activeWidget;
  const videoPlaylists = locals.videoPlaylists;
  const activeUser = locals.activeUser;
  const organizationOwner = locals.organizationOwner;
  const origin = locals.origin;
  const userToRequest = getUserToRequest(activeUser, organizationOwner);
  const [refreshList, setRefreshList] = useState(false);
  const [statusState, setStatusState] = useState("save"); //state to control if the playlist are in "change order" mode or not
  const [editWidgetInfoModalOpened, setEditWidgetInfoModalOpened] =
    useState(false);

  const [formState, setFormState] = useState({}); //state to control the widget's form
  //create a playlist's state
  const [playListFormState, setPlaylistFormState] = useState({
    image: "",
    name: "",
    description: "",
    status: "draft",
    videos: [],
  });
  //edit a playlist's state
  const [playListEditFormState, setPlaylistEditFormState] = useState({
    name: "",
    description: "",
    widget: "",
    image: {},
    id: "",
    status: "draft",
    videos: [],
  });

  //store the playlists
  const [videoPlaylistsState, setVideoPlaylists] = useState([]);

  //control if the "add playlist" section is opened or not
  const [addNewState, setAddNewState] = useState("addNewButton");

  const [orderedPlaylists, setOrderedPlaylists] = useState([]); //array of playlist's ids to reorder them

  /**
   * Reorder
   */
  /**
   * Reorder the widgets
   */
  useEffect(() => {
    scriptLoader(
      "https://cdn.jsdelivr.net/npm/sortablejs@latest/Sortable.min.js",
      () => {
        const dragImage = document.createElement("img");
        dragImage.src =
          "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
        const sortable = new Sortable(
          document.querySelector(".principal-grabber-div"),
          {
            animation: 350,
            handle: ".drag-wrapper",
            setData(dataTransfer) {
              dataTransfer.setDragImage(dragImage, 0, 0);
            },
            onEnd: (e) => {
              if (e.oldIndex === e.newIndex) return;

              const orderedPlaylists = Array.from(
                document.querySelectorAll(".item-grabber-container")
              ).map((item) => item.id);

              setOrderedPlaylists(orderedPlaylists);
            },
          }
        );
      }
    );
  }, []);

  /**
   * Asign the values to the state
   */
  const [compareBase, setCompareBase, setCurrentCompareState, hasChanged] =
    useCompareState();
  useEffect(() => {
    if (!!activeWidget) {
      const comparingBase = {
        name: activeWidget.name,
        description: activeWidget.description,
        icon: activeWidget.icon,
        pushPermission:
          activeWidget.pushPermission === undefined
            ? true
            : activeWidget.pushPermission,
        pullPermission:
          activeWidget.pullPermission === undefined
            ? true
            : activeWidget.pullPermission,
      };
      setFormState({
        ...comparingBase,
        id: activeWidget._id,
      });
      setCompareBase(comparingBase);
      setCurrentCompareState(comparingBase);
    }
    if (!!videoPlaylists) {
      setVideoPlaylists(videoPlaylists);
    }
  }, [activeWidget, videoPlaylists]);

  const {
    description = "",
    name = "",
    icon = "",
    id = 0,
    pushPermission = true,
    pullPermission = true,
  } = formState;

  /**
   * Reorder
   * @param {*} e
   */
  const handleSaveReorderPlayLists = (e) => {
    e.preventDefault();
    if (orderedPlaylists.length > 0) {
      submit("/actions/video-playlist/reorder", {
        method: "POST",
        body: { orderedPlaylists },
      });
    }
    setStatusState("save");
  };
  const cancelReorder = () => {
    setOrderedPlaylists([]);
    setStatusState("save");
    setRefreshList(!refreshList);
  };
  /**
   * Control if the playlist are in "change order" mode
   * @param {*} state
   */
  const handleChangeStatusState = (state) => {
    setStatusState(state);
  };

  /**
   * Validate if the widget's form is valid
   * @returns
   */
  const validationSubmit = () => {
    if (description.length > 0 && name.length > 0 && icon.length > 0) {
      return true;
    }
    return false;
  };

  /**
   * Validate if the playlist's form is valid
   * @returns
   */
  const validationPlaylistSubmit = () => {
    if (
      playListFormState.description.length > 0 &&
      playListFormState.name.length > 0
    ) {
      return true;
    }
    return false;
  };

  /**
   * Assign the value of the edit widgets's state
   * @param {*} param0
   */
  const handleInputChange = ({ target }) => {
    const targetName = target?.name.replace("-mobile", "") || target?.name;
    const newState = Object.assign({}, formState, {
      [targetName]: target.value,
    });
    setFormState(newState);
    setCurrentCompareState({
      ...compareBase,
      [targetName]: target.value,
    });
  };

  /**
   * Assign the value of the create playlist's state
   * @param {*} param0
   */
  const handleInputPlayListChange = ({ target }) => {
    const newState = Object.assign({}, playListFormState, {
      [target.name]: target.value,
    });
    setPlaylistFormState(newState);
  };

  /**
   * Edit widget
   * @param {*} e
   */
  const handleSubmit = (e) => {
    e.preventDefault();
    submit(`/actions/widgets/save/${id}`, {
      method: "POST",
      body: formState,
    });
  };

  /**
   * Control if the "add playlist" section is opened or not
   * @param {*} state
   */
  const handleChangeAddNewState = (state) => {
    setAddNewState(state);
  };

  /**
   * Delete a widget
   * @param {*} e
   */
  const deleteWidget = (e) => {
    if (!!activeWidget) {
      const { _id } = activeWidget;
      deleteWidgetUtil(e, _id);
    }
  };

  /**
   * Delete a video playlist
   * @param {*} e
   * @param {*} id
   */
  const handleDeletePlaylist = (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    if (
      process.browser &&
      confirm("Are you sure you want to delete this Video playlist?")
    ) {
      submit(`/actions/video-playlist/delete/${id}`, {
        method: "GET",
      });
      setPlaylistEditFormState({
        name: "",
        description: "",
        widget: "",
        image: {},
        id: "",
        status: "draft",
        videos: [],
      });
    }
  };

  /**
   * Refresh the page deleting the submited query to can close the "add new playlist" section
   */
  const handleRefresh = () => {
    submit(`/actions/refresh/`, {
      method: "GET",
      body: { submited: "", created: "", edited: "" },
    });
  };

  /**
   * Close the "add new playlist" section, and redirect to playlist after it is created
   */
  useEffect(() => {
    if (locals.query.edited) {
      setPlaylistFormState({
        image: "",
        name: "",
        description: "",
        status: "draft",
        videos: [],
      });
      setAddNewState("addNewButton");
      setStatusState("save");
    }

    if (locals.query.created) {
      // redirect after create
      const foundedArrays = videoPlaylists.filter(
        (element) =>
          element.name === playListFormState.name &&
          element.description &&
          playListFormState.description
      );

      const founded =
        foundedArrays.length > 0
          ? foundedArrays[foundedArrays.length - 1]
          : null;

      if (founded !== null) {
        setPlaylistEditFormState(
          Object.assign({}, playListEditFormState, {
            name: founded.name,
            description: founded.description,
            image: founded.image,
            id: founded._id,
            videos: founded.videos,
          })
        );
      }
      //end redirect

      setAddNewState("addNewButton");
      setStatusState("save");
    }
  }, [locals.query]);

  /**
   * Open the edit widget info modal (only for mobile)
   */
  const onOpenEditWidgetInfo = () => {
    setEditWidgetInfoModalOpened(!editWidgetInfoModalOpened);
  };

  /**
   * Control the widget acess
   * @param {*} param0
   * @returns
   */
  const WidgetTogglePush = ({ permission }) => {
    return (
      <div className="labeled-switch" sz="large">
        <span>Subscriptions (PUSH)</span>
        <input
          type="checkbox"
          id="switch-1"
          name="switch-1"
          role="switch"
          onChange={() => {
            const newState = Object.assign({}, formState, {
              pushPermission: !formState.pushPermission,
            });
            setFormState(newState);
            setCurrentCompareState({
              ...compareBase,
              pushPermission: !formState.pushPermission,
            });
          }}
          checked={permission ? true : undefined}
        />
      </div>
    );
  };

  const WidgetTogglePull = ({ permission }) => {
    return (
      <div className="labeled-switch" sz="large">
        <span>Coaching (PULL)</span>
        <input
          type="checkbox"
          id="switch-1"
          name="switch-1"
          role="switch"
          onChange={() => {
            const newState = Object.assign({}, formState, {
              pullPermission: !formState.pullPermission,
            });
            setFormState(newState);
            setCurrentCompareState({
              ...compareBase,
              pullPermission: !formState.pullPermission,
            });
          }}
          checked={permission ? true : undefined}
        />
      </div>
    );
  };

  return (
    <main className="widgets-manager list video">
      <WidgetManagerHeader
        name={name}
        description={description}
        goBack={goBack}
        onOpenEditWidgetInfo={onOpenEditWidgetInfo}
      />
      <EditWidgetInfoModal
        widgetName={formState.name}
        widgetDescription={formState.description}
        widgetIcon={formState.icon}
        isOpen={editWidgetInfoModalOpened}
        onClose={onOpenEditWidgetInfo}
        handleInputChange={handleInputChange}
        handleSubmit={handleSubmit}
        validationSubmit={validationSubmit}
        iconsRadios={WIDGET_ICONS["video-playlist"]}
        WidgetTogglePull={WidgetTogglePull}
        WidgetTogglePush={WidgetTogglePush}
        userToRequest={userToRequest}
        pullPermission={pullPermission}
        pushPermission={pushPermission}
      />
      <div>
        {!!activeWidget && (
          // show main information
          <aside className="mobile-hidden">
            <div className="overflow-auto max-h-[calc(100vh-16.75rem)]">
              <label> Widget name </label>
              <input
                maxLength="30"
                name="name"
                className="text-input"
                placeholder={`Enter Name`}
                value={name}
                onChange={handleInputChange}
              />
              <label> Widget description </label>
              <textarea
                maxLength="60"
                name="description"
                className="text-input"
                placeholder={`Enter description here..`}
                value={description}
                onChange={handleInputChange}
              />
              <ImageRadio
                label="Widget icon"
                name="icon"
                currentValue={icon}
                radios={WIDGET_ICONS["video-playlist"]}
                onChange={handleInputChange}
                isManager={true}
              />
              <label>User type access</label>
              {isPullActiveCoach(userToRequest) && (
                <WidgetTogglePull permission={pullPermission} />
              )}
              {userToRequest.pushAccountInfo && (
                <WidgetTogglePush permission={pushPermission} />
              )}
            </div>
            <footer>
              <button
                data-button-type="secondary"
                data-action="cancel"
                onClick={deleteWidget}
              >
                Delete
              </button>
              <button
                data-button-type="primary"
                onClick={handleSubmit}
                disabled={!hasChanged}
              >
                Save
              </button>
            </footer>
          </aside>
        )}

        <section>
          {playListEditFormState.id.length === 0 ? (
            <>
              <header>
                <section className="only-show-mobile back-handler">
                  <SvgIcon
                    src={"/img/new-icons/back-button.svg"}
                    onClickFn={() =>
                      submit(`/actions/refresh/?`, {
                        method: "GET",
                        body: { section: "", learn: "" },
                      })
                    }
                  />
                  <h3>{activeWidget?.name || "Explore"}</h3>
                </section>
                <hgroup className="mobile-hidden">
                  <h4>Videos</h4>
                  <p className="p6">Create and manage video playlists</p>
                </hgroup>
                {statusState === "save" ? (
                  <button
                    data-button-type="secondary"
                    onClick={() => handleChangeStatusState("change-order")}
                  >
                    Change order
                  </button>
                ) : (
                  <hgroup className="action-buttons">
                    <button
                      data-button-type="secondary"
                      data-action="cancel"
                      onClick={cancelReorder}
                    >
                      Cancel
                    </button>
                    <button
                      data-button-type="primary"
                      onClick={handleSaveReorderPlayLists}
                      disabled={orderedPlaylists.length === 0}
                    >
                      Save
                    </button>
                  </hgroup>
                )}
              </header>

              <div className="principal-grabber-div principal-explore">
                {/* playlists section */}

                {!!videoPlaylistsState &&
                  orderWidgets(videoPlaylistsState).map(
                    ({ _id, description, name, image, status, videos }, i) => {
                      return (
                        <div
                          key={`${_id}-${i}-${refreshList}`}
                          id={_id}
                          className={`item-grabber-container article-wrapper video`}
                        >
                          <article
                            className={
                              statusState === "change-order" ? " column" : ""
                            }
                          >
                            <div>
                              <div>
                                <img src={S3.toCDN(image.s3Path)} />
                              </div>
                              <div>
                                <p className="s2">{name}</p>
                                <p className="p4">{description}</p>
                              </div>
                            </div>
                            <div className="action-buttons">
                              <div>
                                <button
                                  data-button-type="secondary"
                                  data-icon-only
                                >
                                  <SvgIcon
                                    src={"/img/new-icons/edit-pencil.svg"}
                                    onClickFn={() => {
                                      setPlaylistEditFormState(
                                        Object.assign(
                                          {},
                                          playListEditFormState,
                                          {
                                            name: name,
                                            description: description,
                                            image: image,
                                            id: _id,
                                            videos: videos,
                                          }
                                        )
                                      );
                                    }}
                                  />
                                </button>
                                <button
                                  data-button-type="secondary"
                                  data-icon-only
                                >
                                  <SvgIcon
                                    src={"/img/new-icons/red-trash.svg"}
                                    onClickFn={(event) => {
                                      handleDeletePlaylist(event, _id);
                                    }}
                                    noFilterOnLight={true}
                                  />
                                </button>
                              </div>
                              <div className="publish-switch-wrapper">
                                <WidgetToggle status={status} id={_id} />
                              </div>
                            </div>
                          </article>
                          {statusState === "change-order" && (
                            <div className="drag-wrapper">
                              <SvgIcon
                                src="/img/new-icons/menu.svg"
                                className="drag-handle"
                                mobileSrc="/img/new-icons/drag.svg"
                              />
                            </div>
                          )}
                        </div>
                      );
                    }
                  )}
              </div>
              {addNewState !== "addNewForm" && (
                <div
                  className="dashed-box"
                  onClick={() => {
                    handleChangeAddNewState("addNewForm");
                    handleRefresh();
                    setPlaylistFormState({
                      image: "",
                      name: "",
                      description: "",
                      status: "draft",
                      videos: [],
                    });
                  }}
                >
                  <SvgIcon
                    src="/img/new-icons/add-square-outline.svg"
                    alt="back"
                  />
                  <span>Add New Playlist</span>
                </div>
              )}
              {addNewState === "addNewForm" && (
                <form
                  encType="multipart/form-data"
                  method="POST"
                  data-noreset
                  action={`/actions/video-playlist/save/`}
                  className="add-videoplaylist-form"
                >
                  <ImageWidgetUploadInput
                    name="image"
                    prefix="Video playlist"
                    defaultValue={playListFormState.image}
                  />
                  <div>
                    <div>
                      <div className="input-box">
                        <label> Video playlist name </label>
                        <input
                          name="name"
                          className="input-videoplaylist-name text-input"
                          placeholder={`Enter Name`}
                          value={playListFormState.name}
                          onChange={handleInputPlayListChange}
                        />
                      </div>
                      <div className="input-box">
                        <label> Description </label>
                        <textarea
                          name="description"
                          className="textarea-input"
                          value={playListFormState.description}
                          onChange={handleInputPlayListChange}
                          placeholder="Enter description"
                        />
                      </div>
                      <input
                        name="widget"
                        style={{ display: "none" }}
                        defaultValue={id}
                      />
                    </div>
                    <div className="flex flex-row gap-2 mt-4">
                      <button
                        data-button-type="primary"
                        type="submit"
                        disabled={!validationPlaylistSubmit()}
                      >
                        Save
                      </button>
                      <button
                        data-button-type="text-white"
                        data-action="cancel"
                        onClick={(e) => {
                          e.preventDefault();
                          setAddNewState("addNewButton");
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </>
          ) : (
            // edit playlist section
            <EditPlaylist
              nameProps={playListEditFormState.name}
              descriptionProps={playListEditFormState.description}
              imageProps={playListEditFormState.image}
              idProps={playListEditFormState.id}
              videosProps={playListEditFormState.videos}
              playListEditFormState={playListEditFormState}
              setPlaylistEditFormState={setPlaylistEditFormState}
              locals={locals}
              handleDeletePlaylist={handleDeletePlaylist}
              WidgetToggle={
                <WidgetToggle
                  status={playListEditFormState.status}
                  id={playListEditFormState.id}
                />
              }
            />
          )}
        </section>
      </div>
    </main>
  );
};
